import React, { useRef, useState } from "react";
import axios from "axios";
import ReCAPTCHA from 'react-google-recaptcha';


const ContactForm = () => {

    const formId = "GZ80BKC3";
    const formSparkUrl = `https://submit-form.com/${formId}`;
    const recaptchaKey = '6LdOJGkgAAAAAOmNcmfj0lxOrvJnUhtKs7xUPWGf';
    const recaptchaRef = useRef();

    const initialFormState  = {
        name: "",
        email: "",
        message: ""
    };

    const [formState, setFormState] = useState(initialFormState);
    const [submitting, setSubmitting] = useState(false);
    const [recaptchaToken, setReCaptchaToken] = useState('');
    
    
    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        await postSubmission();
      };
    
    const postSubmission = async () => {
      
        const payload = {
          ...formState,
          "g-recaptcha-response": recaptchaToken,
        };
    
        try {
          await axios.post(formSparkUrl, payload);
          setFormState(initialFormState);
          recaptchaRef.current.reset();
        } 
        catch (error) {
          console.log(error)
        }
      };

    const updateFormControl = (event) => {
      const { id, value } = event.target;
      const key = id;
      const updatedFormState = { ...formState };
      updatedFormState[key] = value;
      setFormState(updatedFormState);
    };
  
    
      const updateRecaptchaToken = (token) => {
        setReCaptchaToken(token);
      };
    
  return (
      <div>
        { submitting ?  
        <div>
            <h3 style={{color:'white', marginTop:80}}> Thank you for your message, I will be in touch shortly.</h3> 
        </div>
        :
            <form id="contact-form" className="form-horizontal">
        
                <div className="form-group">
                    <div className="col-sm-12">
                    <input type="text"
                            className="form-control"
                            placeholder="NAME" 
                            name="name"
                            id="name"
                            onChange={updateFormControl}
                            value={formState.name}
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-sm-12">
                    <input  type="email" 
                            className="form-control" 
                            id="email" 
                            name="email"
                            value={formState.email}
                            placeholder="EMAIL" 
                            onChange={updateFormControl}
                            required />
                    </div>
                </div>

                <textarea className="form-control" 
                            rows="10" 
                            id="message"
                            value={formState.message}
                            placeholder="MESSAGE" 
                            name="message" 
                            onChange={updateFormControl}
                            required>
                            </textarea>


                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={recaptchaKey}
                    onChange={updateRecaptchaToken}
                />   

                <button className="btn send-button" 
                        style={{backgroundColor: '#fff', color: '#000',width:430}}
                        id="submit" 
                        type="submit" 
                        onClick={handleSubmit}
                        value="SEND" >
                        <div className="alt-send-button">
                        <i className="fa fa-paper-plane"></i>
                        <span className="send-text">SEND</span>
                        </div>
                </button>
        
            </form> 
            }
    </div> 
  )
}



export default ContactForm